import { gql } from "@apollo/client";

export const GET_SUBSCRIBERS = gql`
  query GetSubscribers {
    subscribers {
      id
      email
      createdAt
    }
  }
`;
